export default __webpack_public_path__ + "6d8c882b43ec679c71481ef908e51389.png";